// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => ("core.ruffle." + {"110":"9b894648ca74129e089e","993":"42b0080302b73eae09c9"}[chunkId] + ".js");